import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import useTabs from "../../hooks/useTabs";
import AnalyticsStore from "../../stores/AnalyticsStore";
import EnrollmentsTab from "./EnrollmentsTab";
import SupportFeesTab from "./SupportFeesTab";
import ReportTab from "./ReportTab";
import "./Analytics.scss";

const sections = [
  { title: "Enrollments", component: EnrollmentsTab },
  { title: "Support Fees", component: SupportFeesTab },
  { title: "Reports", component: ReportTab }
];

const Tab = ({ index, title, select, activeTabIndex }) => (
  <div className={`tab${index === activeTabIndex ? " active" : ""}`} onClick={select}>
    {title}
  </div>
);

function Analytics() {
  const navigate = useNavigate();
  const { activeTabIndex, tabKeys } = useTabs(sections);
  const selectTab = index => () => navigate(`/analytics?tab=${tabKeys[index]}`);

  useEffect(() => {
    AnalyticsStore.init();
  }, []);

  const tabs = sections?.map(({ title }, index) => (
    <Tab {...{ index, title, select: selectTab(index), activeTabIndex }} key={title} />
  ));

  const tabBarStyles = { gridTemplateColumns: `repeat(${sections.length}, 1fr)` };

  // Get the active section component reference (not creating a new component, just getting reference)
  const ActiveSection = sections?.[activeTabIndex]?.component;

  return (
    <div className="analytics">
      <div className="title-row">
        <div className="title">Reports & Analytics</div>
      </div>
      <div className="tabs-container">
        <div className="tab-bar" style={tabBarStyles}>
          {tabs}
        </div>
        <div className="active-tab-section">
          {ActiveSection && <ActiveSection />}
        </div>
      </div>
    </div>
  );
}

export default observer(Analytics);
